import apiAnalytic from '@/api/shelters-map'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getSheltersMapByParamsStart: '[sheltersMap] Get sheltersMap by params start',
  getSheltersMapByParamsSuccess:
    '[sheltersMap] Get sheltersMap by params success',
  getSheltersMapByParamsFailure:
    '[sheltersMap] Get sheltersMap by params failure',
}

export const actionTypes = {
  getSheltersMapByParams: '[sheltersMap] Get sheltersMap by params',
}

const mutations = {
  [mutationTypes.getSheltersMapByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getSheltersMapByParamsSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getSheltersMapByParamsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getSheltersMapByParams](context) {
    context.commit(mutationTypes.getSheltersMapByParamsStart)
    return new Promise((resolve) => {
      apiAnalytic
        .getSheltersMapByParams()
        .then((response) => {
          const sheltersMap = response.data ? response.data : response
          context.commit(mutationTypes.getSheltersMapByParamsSuccess, response)
          resolve(sheltersMap)
        })
        .catch(() => {
          context.commit(mutationTypes.getSheltersMapByParamsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
